import React from 'react';
import {css, useTheme} from "@emotion/react";
import { em } from "@util/convertUnits";
import PropTypes from "prop-types";
import CmsImageLoader from "../../../base/CmsImageLoader";

const ApplicationOptionsWidget = ({content}) => {
    const theme = useTheme();
    const fontTheme = theme.header.fontFamily;

    const containerStyles = css(`
        justify-content: center;
        align-items: center;
        display:flex;
        padding-bottom: 3.6rem;
        
        @media (min-width: ${em(theme.breakpoint.ns, 16)}) {
            padding-bottom: 0;
        }
    `);

    const labelAndDescriptionContainer = css(`
        display:flex;
        width:8em;
        flex-direction: column;
        min-height:8em;
        font-family:${fontTheme};
        @media (min-width: ${em(theme.breakpoint.ns, 16)}) {
            justify-content: start;
            width: 25em;
            margin-left:1.5em;
            align-items: left;
            min-height:5em;
            max-height:5em;
        }
    `);

    const imgStyles = css(`
        min-height: 4em;
        max-height: 6em;
        
        @media (min-width: ${em(theme.breakpoint.ns, 16)}) {
            min-height: 8em;
            max-height: 8em;
        }
    `)

    const descriptionStyles = css(`
        font-size: 12px;
    `)

    const labelStyles = css(`
        color: black;
        margin-bottom:1em;
    `);

    return (
   <div>
        {content.items.map((item) => (
            <div key={item.image_url} css={containerStyles}>
                <div css={imgStyles}>
                    <CmsImageLoader url={item.image_url} alt={item.alt_text}
                                    style={{width: "100%", height: "100%", objectFit: "cover"}} />
                </div>
                <div css={labelAndDescriptionContainer}>
                    <div css={labelStyles}>{item.label}</div>
                    <div css={descriptionStyles}>{item.description}</div>
                </div>
            </div>)
        )}
    </div>
    )};

ApplicationOptionsWidget.propTypes = {
    content: PropTypes.object
};

export default ApplicationOptionsWidget;